import React, { Component } from 'react';
import { BrowserRouter, Route, Switch,Redirect } from 'react-router-dom';

import { ProtectedRoute } from './hoc/protectedroute';

import {
  Login,
  AdminSys,
  Officer,
  Admin,
  EditOfficer,
  EditCompany,
  EditRice,
  AddRice,
  AddCompany,
  AddOfficer,
  Surveyor,
  EditProfile,
  Request,
  Job,
  AddJob,
  CheckWeight,
  FinancialAccount,
  Guest,
  Landing,
  ValidateCheckWeight,
  ValidateFinancial,
  Warning500,
  Warning404,
  ValidPageTable,
  ValidatePage,
  Certificate,
  CertiPage,
  Statistics,
  JobCalendar,
  Requested,
  RequestDaily,
  RequestEditCalendar,
  RequestEditTable,
  RequestEdit,
  RequestCalendar,
  RequestMemCalendar,
  RequestMemDaily,
  RequestDate,
  RequestTable,
  CheckWeightCalendar,
  CheckWeightTable,
  CertificateCalendar,
  CertificateTable,
  UploadCheckWeight,
  ViewCheckWeight,
  HealthCert,
  ValidCalendar,
  FinancialWageTable,
  FinancialWageCalendar,
  EditSurvey,
  SumCertificate,
  CertificateRequested,
  FinancialWageMonthlyTable,
  FinancialWageSetting,
  AddSurvey,
  FinancialWageVehicle,
  FinancialWageMonthlyTableMonthly,
  testExcel,
  FinancialCompany,
  JobSummary
} from './pages';


import './App.css';
class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Landing} />
          <Route path="/guest" component={Guest} />
          <Route path="/login" component={Login} />
          <ProtectedRoute
            path="/adminsys"
            component={AdminSys}
            neededRole={'admin'}
          />
          <ProtectedRoute
            path="/admin"
            component={Admin}
            neededRole={'admin'}
          />
          <ProtectedRoute
            path="/officer"
            component={Officer}
            neededRole={'officer'}
          />
          <ProtectedRoute
            path="/surveyor"
            component={Surveyor}
            neededRole={'surveyor'}
          />
          <Route path="/EditProfile" component={EditProfile} />
          <Route path="/addOfficer" component={AddOfficer} />
          <Route path="/EditOfficer" component={EditOfficer} />
          <Route path="/EditCompany" component={EditCompany} />
          <Route path="/AddCompany" component={AddCompany} />
          <Route path="/EditRice" component={EditRice} />
          <Route path="/EditSurvey" component={EditSurvey} />
          <Route path="/AddRice" component={AddRice} />
          <Route path="/Request" component={Request} />
          <Route path="/Job" component={Job} />
          <Route path="/JobCalendar" component={JobCalendar}/>
          <Route path="/AddJob" component={AddJob} />
          <Route path="/Checkweight" component={CheckWeight} />
          <Route path="/FinancialAccount" component={FinancialAccount} />
          <Route path="/JobSummary" component={JobSummary} />

          
          <Route
            path="/ValidateCheckWeight"
            component={ValidateCheckWeight}
          />
          <Route
            path="/ValidateFinancial"
            component={ValidateFinancial}
          />
          <Route path="/ValidCalendar" component={ValidCalendar}/>
          <Route path="/ValidateCheckWeight" component={ValidateCheckWeight} />
          <Route path="/ValidateFinancial" component={ValidateFinancial} />
          <Route path="/ValidPageTable" component={ValidPageTable} /> 
          {/* ValidPageTable คือส่วนวิเคราะห์ */}
          <Route path="/ValidatePage" component={ValidatePage} />
          <Route path="/Certificate" component={Certificate} />
          <Route path="/CertiPage" component={CertiPage} />
          <Route path="/Statistics" component={Statistics} />
          <Route path="/Requested" component={Requested} />
          <Route path="/RequestDaily" component={RequestDaily} />
          <Route path="/RequestEditCalendar" component={RequestEditCalendar}/>
          <Route path="/RequestEditTable" component={RequestEditTable}/>
          <Route path="/RequestEdit" component={RequestEdit}/>
          <Route path="/RequestCalendar" component={RequestCalendar}/>
          <Route path="/RequestMemCalendar" component={RequestMemCalendar} />
          <Route path="/RequestMemDaily" component={RequestMemDaily} />
          <Route path='/RequestTable' component={RequestTable} />
          <Route path='/RequestDate' component={RequestDate} />
          <Route path='/CheckWeightCalendar' component={CheckWeightCalendar} />
          <Route path='/CheckWeightTable' component={CheckWeightTable} />
          <Route path='/CertificateCalendar' component={CertificateCalendar} />
          <Route path='/CertificateTable' component={CertificateTable} />
          <Route path='/SumCertificate' component={SumCertificate} />
          <Route path='/UploadCheckWeight' component={UploadCheckWeight}/>
          <Route path='/ViewCheckWeight' component={ViewCheckWeight}/>
          <Route path='/HealthCert' component={HealthCert}/>
          <Route path='/FinancialWageTable' component={FinancialWageTable}/>
          <Route path='/FinancialWageCalendar' component={FinancialWageCalendar}/>
          <Route path='/CertificateRequested' component={CertificateRequested}/> 
          <Route path='/FinancialWageMonthlyTable' component={FinancialWageMonthlyTable}/> 
          <Route path='/FinancialWageSetting' component={FinancialWageSetting}></Route>
          <Route path='/AddSurvey' component={AddSurvey}></Route>
          <Route path='/FinancialWageVehicle' component={FinancialWageVehicle}></Route>
          <Route path='/FinancialWageMonthlyTableMonthly' component={FinancialWageMonthlyTableMonthly}></Route>
          <Route path='/testExcel' component={testExcel}></Route>
          <Route path='/FinancialCompany' component={FinancialCompany}></Route>
          
          <Route path="/500" component={Warning500} />
          <Route path="/404" component={Warning404} />
          <Redirect to="/404" />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
